module.exports = __webpack_public_path__ + "static/media/dont1.0d94490b.png";